import { render } from "./Branches.vue?vue&type=template&id=5c5a986a"
import script from "./Branches.vue?vue&type=script&lang=js"
export * from "./Branches.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__